import React, { useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../../../Axios'

const AddStaffForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    Qualification: '',
    department: '',
    Specialization: '',
    Experience: '',
    profilePhoto: null, // To store the file
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'profilePhoto') {
      setFormData((prev) => ({
        ...prev,
        [name]: files[0], // Store the file in state
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Profile photo validation (if required)
    // if (!formData.profilePhoto) {
    //   toast.error('Please upload a profile photo.');
    //   setLoading(false);
    //   return;
    // }

    // Create FormData object
    const data = new FormData();
    data.append('name', formData.name);
    data.append('Qualification', formData.Qualification);
    data.append('department', formData.department);
    data.append('Specialization', formData.Specialization);
    data.append('Experience', formData.Experience);

    // Append the profile photo
    data.append('profilePhoto', formData.profilePhoto);

    try {
      const response = await api.post('/api/v1/staff', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      toast.success('Staff added successfully!');
      setFormData({
        name: '',
        Qualification: '',
        department: '',
        Specialization: '',
        Experience: '',
        profilePhoto: null,
      });
    } catch (error) {
      toast.error(error.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-6">
      <motion.div
        className="bg-white shadow-xl rounded-lg p-10 w-full max-w-3xl"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-semibold text-white text-center py-4 mb-8 rounded-t-lg" style={{ backgroundColor: '#00BFA5' }}>
          Add New Staff
        </h2>
        <form onSubmit={handleSubmit}>
          {['name', 'Qualification', 'department', 'Specialization', 'Experience'].map((field) => (
            <div className="mb-6" key={field}>
              <label htmlFor={field} className="block text-gray-600 text-sm font-medium mb-2 capitalize">
                {field}
              </label>
              <input
                type={field === 'Experience' ? 'number' : 'text'}
                id={field}
                name={field}
                value={formData[field]}
                onChange={handleChange}
                placeholder={`Enter ${field}`}
                required
                className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
              />
            </div>
          ))}
          <div className="mb-6">
            <label htmlFor="profilePhoto" className="block text-gray-600 text-sm font-medium mb-2">
              Profile Photo
            </label>
            <input
              type="file"
              id="profilePhoto"
              name="profilePhoto"
              onChange={handleChange}
              accept="image/*" // Accept only image files
              className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
            />
          </div>
          <motion.button
            type="submit"
            className={`w-48 mx-auto py-3 rounded-lg font-semibold shadow-md focus:outline-none focus:ring-2 ${
              loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#00BFA5] hover:bg-[#00BFA5] text-white'
            }`}
            disabled={loading}
            whileTap={{ scale: 0.98 }}
            style={{ fontSize: '1rem' }}
          >
            {loading ? 'Adding...' : 'Add Staff'}
          </motion.button>
        </form>
      </motion.div>
      <ToastContainer />
    </div>
  );
};

export default AddStaffForm;
